import React, { useEffect } from 'react';
import styled from 'styled-components';
import { CreateTokenForm } from '../../components/explore/CreateTokenSection';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const CreateWrapper = styled.div`
  width: 100% !important;
  max-width: 100% !important;
  min-height: 100%;
  flex: 1;
  overflow-x: hidden;
  
  /* Direct child overrides for PageWrapper */
  & > div {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    justify-content: flex-start !important;
    min-height: 100% !important;
    
    /* Direct child overrides for CreateContainer */
    & > div {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 16px !important;
      border-radius: 0 !important;
      min-height: 100% !important;
      box-sizing: border-box !important;
      
      /* Override any nested FormContainer or other containers */
      & > * {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      
      @media (min-width: 768px) {
        padding: 20px !important;
      }
    }
  }
`;

const CreateTokenPWA: React.FC = () => {
  useEffect(() => {
    // Add body class for PWA create page styling
    document.body.classList.add('pwa-create-page');
    
    // Function to remove maxWidth constraints from Token Preview containers
    const removeMaxWidthConstraints = () => {
      // Find all elements with inline styles containing maxWidth
      const allElements = document.querySelectorAll('.pwa-create-wrapper [style*="maxWidth"]');
      allElements.forEach((el) => {
        const htmlEl = el as HTMLElement;
        const style = htmlEl.getAttribute('style') || '';
        // Remove maxWidth from inline styles
        if (style.includes('maxWidth')) {
          const newStyle = style
            .replace(/maxWidth:\s*\d+/g, '')
            .replace(/max-width:\s*\d+px/g, '')
            .replace(/margin:\s*['"]?0\s+auto['"]?/g, 'margin: 0')
            .replace(/,\s*,/g, ',')
            .replace(/^,\s*/, '')
            .replace(/,\s*$/, '')
            .trim();
          htmlEl.setAttribute('style', newStyle || 'width: 100%');
          // Also set via style property to ensure it takes effect
          htmlEl.style.maxWidth = '100%';
          htmlEl.style.width = '100%';
          htmlEl.style.margin = '0';
        }
      });
    };
    
    // Run immediately and also set up a mutation observer to catch dynamically added elements
    const observer = new MutationObserver(() => {
      removeMaxWidthConstraints();
    });
    
    // Start observing
    const wrapper = document.querySelector('.pwa-create-wrapper');
    if (wrapper) {
      observer.observe(wrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
      // Initial run
      setTimeout(removeMaxWidthConstraints, 100);
    }
    
    return () => {
      document.body.classList.remove('pwa-create-page');
      observer.disconnect();
    };
  }, []);

  return (
    <PageContainer>
      <CreateWrapper className="pwa-create-wrapper">
        <CreateTokenForm 
          isVisible={true}
          asPage={true}
          onClose={() => {
            // Navigate handled by bottom nav
          }} 
        />
      </CreateWrapper>
    </PageContainer>
  );
};

export default CreateTokenPWA;

